<header>
  <div class="d-flex">
    <h3 class="title">
        <fa-icon [icon]="['fas', 'shopping-bag']" ></fa-icon>&nbsp;
        <span *ngIf="strViewType == 'edit'" >{{ 'edit_supplier_invoice'| translate }} </span>
        <span *ngIf="strViewType == 'add'">{{ 'create_supplier_invoice'| translate }} </span>
    </h3>
    <ng-container *fcHasPermission="'supplier_invoices' + ((strViewType == 'add') ? ':create' : ':edit')">
      <div class="ml-auto d-flex">
        <ul class="list-inline pull-right">
          <li class="list-inline-item">
            <form-real-time-pdf-preview
              [disabled]="isPreviewTemplate || !bInvoiceLineLoaded || bSubmitted || (whenInProgress$ | async)"
              (click)="onPreview()"
              [trigger-event]="realTimePreviewTemplate.asObservable()"
              (onComplete)="whenInProgress$.next(false)">
            </form-real-time-pdf-preview>
          </li>
          <li class="list-inline-item">
            <form-templates-save-and-preview-btn
              [disabled]="isPreviewTemplate || !bInvoiceLineLoaded || bSubmitted || (whenInProgress$ | async)"
              (click)="onSubmitAndPreview()"
              [trigger-event]="previewTemplate.asObservable()">
            </form-templates-save-and-preview-btn>
          </li>
          <li class="list-inline-item">
            <button (click)="saveSupplierInvoice()" class="btn btn-primary" [disabled]="bSubmitted || !bInvoiceLineLoaded || (whenInProgress$ | async)">
              <fa-icon *ngIf="!bSubmitted" [icon]="['fas', 'save']"></fa-icon>
              <fa-icon *ngIf="bSubmitted" [icon]="['fas', 'spinner']" [spin]="true" aria-hidden="true"></fa-icon>
              <span class="pl-1">{{ 'save' | translate }}</span>
            </button>
          </li>
          <li class="list-inline-item">
            <fieldmagic-primary-button
              id="exit-dialog"
              variant="error"
              (click)="cancelDialog()"
              icon="times"
              label="close"
              [disabled]="bSubmitted || !bInvoiceLineLoaded || (whenInProgress$ | async)"
            ></fieldmagic-primary-button>
          </li>
        </ul>
      </div>
    </ng-container>
  </div>
</header>

<hr class="separator"/>

<ng-container *fcHasPermission="'supplier_invoices' + ((strViewType == 'add') ? ':create' : ':edit'); else createSIDisabled">
<mat-dialog-content *ngIf="supplierInvoiceForm" class="mobile-view-dialog">
<app-error-handler onlyFor="edit_form" [isAction]="true" alignment="center">
  <div *ngIf="supplierInvoiceForm.length != 0" class="mt-3">
    <ul class="nav nav-tabs" id="myTab" role="tablist">
      <li *ngFor="let item of supplierInvoiceForm" class="nav-item text-size">
        <a class="nav-link" [ngClass]="{'active': supplierInvoiceForm[0]['label'] == item.label}" id="{{item.label}}-tab" data-toggle="tab" href="#{{item.id}}" role="tab" aria-selected="true" translate>{{ item.label }}</a>
      </li>
    </ul>
    <div class="tab-content">
        <div *ngFor="let item of supplierInvoiceForm" [ngClass]="{'active': supplierInvoiceForm[0]['label'] == item.label, 'show': supplierInvoiceForm[0]['label'] == item.label}" class="tab-pane row p-4" [id]="item.id" role="tabpanel">
          <fieldmagic-alert mode="info" *ngIf="strPurchasingNotes" class="w-100 text-left">
            <span>{{ strPurchasingNotes }}</span>
          </fieldmagic-alert>
          <form [formGroup]="item.groups">
            <div class="row">
              <ng-container *ngFor="let data of item.fields">
                <div *ngIf="data.label != 'status'" class="col-{{data.space}} mb-3">
                  <ng-container *ngIf="(( data.label != 'created_by' && data.label != 'modified_by' && data.label != 'updated_at' && data.label != 'created_at') && strViewType == 'add') || strViewType == 'edit'">
                    <app-edit-field *ngIf="data.key != 'line_items' else lineItems" [item]="data" [form]="item.groups" [bSubmitted]="bSubmitted" [strMode]="strViewType" strModule="supplier_invoices" [strRecordId]="" [autoSelectResult]="true" (objCurrentValue)="getRelateObject(data, $event)" (strCurrentValue)="getRelateText(data, $event)" (parentEvent)="doSomethingInParent($event)" ></app-edit-field>
                  </ng-container>
                </div>
              </ng-container>
            </div>
          </form>
        </div>
    </div>
  </div>
  <div align="center">
    <fa-icon *ngIf="supplierInvoiceForm.length == 0" [icon]="['fas', 'spinner']" [spin]="true" class="loading-spinner" aria-hidden="true"></fa-icon>
  </div>
</app-error-handler>
</mat-dialog-content>
<!-- Flexible and Milestone Invoicing Field -->
<ng-template #lineItems>
<div class="row">
  <div *ngIf="isRelatedToPO">
    <div class="col-12 mb-3 ">
      <label class="labels">{{ 'mark_purchase_order_as_invoiced' | translate }}</label>
      <div class="input-group">
        <mat-slide-toggle [(ngModel)]="markAsInvoiced">
        </mat-slide-toggle>
      </div>
    </div>
  </div>
  <div *ngIf="isRelatedToJob">
    <div class="col-12 mb-3 ">
      <label class="labels">{{ 'create_update_material_in_related_job' | translate }}</label>
      <div class="input-group">
        <mat-slide-toggle [(ngModel)]="upsertMaterial">
        </mat-slide-toggle>
      </div>
    </div>
  </div>
</div>
<div class="col-12">
  <div class="row">
    <div class="col-12 p-0">
      <label class="labels">
        {{ 'line_items' | translate }}
      </label>
    </div>
    <div class="col-12 p-0 mb-2">
      <browse-products (objProductSelected)="addLineAttribute($event, true, true)" [bLabor]="false" [bSales]="false"></browse-products>
    </div>

    <div class="col-12 p-0">
      <div class="row">

        <div class="col-12">
          <div class="d-flex flex-row border">
            <div class="daggable-table-box-header" style="width: 8%"></div>
            <div class="draggable-table-box-header" [ngStyle]="{ width: bDepartmentTracking ? '17%' : '30%'}">
              <b>{{ 'description' | translate }}</b>
            </div>
            <div *ngIf="bDepartmentTracking" class="draggable-table-box-header" style="width: 12%">
              <b>{{ 'department' | translate }}<required-tag></required-tag></b>
            </div>
            <div class="draggable-table-box-header" style="width: 10%">
              <b>{{ 'quantity' | translate }}</b>
            </div>
            <div class="draggable-table-box-header" style="width: 10%">
              <b>{{ 'unit_cost' | translate }}</b>
            </div>
            <div class="draggable-table-box-header" style="width: 12%">
              <b>{{ 'tax_code' | translate }}<required-tag></required-tag></b>
            </div>
            <div class="draggable-table-box-header" style="width: 12%">
              <b>{{ 'account_code' | translate }}<required-tag></required-tag></b>
            </div>
            <div class="draggable-table-box-header" style="width: 10%">
              <b>{{ 'amount' | translate }}</b>
            </div>
            <div
              (mouseover)="iconDisplay.supplier_pricing=false"
              (mouseout)="iconDisplay.supplier_pricing=true"
              class="draggable-table-box-header pl-2"
              style="width: 3%">
              <fieldmagic-icon *ngIf="iconDisplay.supplier_pricing" icon="dollar-sign" customClass="pl-1"></fieldmagic-icon>
              <span *ngIf="!iconDisplay.supplier_pricing" class="pt-1">
                <input
                  type="checkbox"
                  [(ngModel)]="bUpdateAllUnitCost"
                  (change)="onChangeCheckbox($event, 'update_supplier_pricing')"
                  class="p-0 m-0"
                  style="height: 13px !important;"
                  matTooltip="{{ 'create_update_supplier_pricing' | translate }}" />
              </span>
            </div>
            <div
              (mouseover)="iconDisplay.product_supplier=false"
              (mouseout)="iconDisplay.product_supplier=true"
              class="draggable-table-box-header pl-1"
              style="width: 3%">
              <fieldmagic-icon *ngIf="iconDisplay.product_supplier" icon="user" customClass="pl-1"></fieldmagic-icon>
              <span *ngIf="!iconDisplay.product_supplier" class="pl-1 pt-1">
                <input
                  type="checkbox"
                  [(ngModel)]="bUpdateAllSupplier"
                  (change)="onChangeCheckbox($event, 'update_product_supplier'); onChangeSupplierCheckbox($event);"
                  class="p-0 m-0"
                  style="height: 13px !important;"
                  matTooltip="{{ 'update_product_preferred_supplier' | translate }}" />
              </span>
            </div>
            <div
              (mouseover)="iconDisplay.product_unit_cost=false"
              (mouseout)="iconDisplay.product_unit_cost=true"
              class="draggable-table-box-header pl-1"
              style="width: 3%">
              <fieldmagic-icon *ngIf="iconDisplay.product_unit_cost" icon="box-open" customClass="pl-1"></fieldmagic-icon>
              <span *ngIf="!iconDisplay.product_unit_cost" class="pl-1 pt-1">
                <input
                  type="checkbox"
                  [(ngModel)]="bUpdateAllProductUnitCost"
                  (change)="onChangeCheckbox($event, 'update_product_buy_price')"
                  class="p-0 m-0"
                  style="height: 13px !important;"
                  matTooltip="{{ 'update_product_buy_price' | translate }}" />
              </span>
            </div>
          </div>
        </div>

        <div *ngIf="bInvoiceLineLoaded" class="col-12">
          <div cdkDropList (cdkDropListDropped)="drop($event)" class="row">

            <ng-container *ngFor="let attr of arLineAttributes; index as i">
              <div cdkDrag class="col-12">
                <div
                  class="d-flex flex-row border border-top-0 bg-white"
                  [ngClass]="{
                    'multiple-selected': contextMenuService.isLineItemSelected(attr, selectedLineItems),
                    'row-focused': (focusedLineIndex - 1) == i
                  }"
                  (click)="onLineFocus(i)"
                >

                  <div class="draggable-table-box center-items pr-2 pl-2" style="width: 2%;"
                    [shAttachMenu]="contextMenuComponent?.menu"
                    [shMenuData]="contextMenuService.formatMenuData(attr, i)"
                    (click)="onClickedLineItem($event, attr)"
                    matTooltip="{{ 'copy_paste_info' | translate }}"
                    matTooltipPosition="right"
                  >
                    <fa-icon
                      cdkDragHandle
                      style="cursor: grab;"
                      [icon]="['fas', 'grip-vertical']"
                      class="pl-2">
                    </fa-icon>
                  </div>

                  <div class="draggable-table-box center-items" style="width: 6%;"
                    [shAttachMenu]="contextMenuComponent?.menu"
                    [shMenuData]="contextMenuService.formatMenuData(attr, i)"
                    (click)="onClickedLineItem($event, attr)"
                    matTooltip="{{ 'copy_paste_info' | translate }}"
                    matTooltipPosition="right"
                  >
                    <fa-icon *ngIf="arLineAttributes.length > 1" (click)="removeAttribute(attr)"
                      class="pl-1 pr-1 pb-2 pt-2 text-danger pointer col-sm-3"
                      [icon]="['fal', 'minus-circle']">
                    </fa-icon>

                    <a *ngIf="attr['supplier_invoice']['item_id']"
                      href="/#/items/{{ attr['supplier_invoice']['item_id'] }}"
                      class="pl-1 pr-1 pb-2 pt-2 col-sm-3"
                      target="_blank">
                      <fa-icon
                        matTooltipClass="tooltip-space"
                        matTooltip="
                        {{ 'click_to_view' | translate }}&#13;&#13;
                        {{ 'product' | translate }}: {{ attr['supplier_invoice']['item_name'] }}&#13;
                        {{ 'code' | translate }}: {{ attr['supplier_invoice']['item_code'] | placeholdWithString }}&#13;
                        {{ 'preferred_supplier' | translate }}: {{ attr['supplier_invoice']['preferred_supplier_text'] | placeholdWithString }}&#13;
                        {{ 'current_stock_level' | translate }}: {{ attr['supplier_invoice']['current_stock_level'] }}"
                        class="text-primary"
                        [icon]="['fas', 'info-circle']">
                      </fa-icon>
                    </a>
                    <fa-icon *ngIf="attr['supplier_invoice']['item_id']"
                      [icon]="['fas', 'chart-line']"
                      class="text-primary desktop-container pointer pl-1 pr-1 pb-2 pt-2 col-sm-3"
                      matTooltip="{{ 'show_stock_levels_and_supplier_pricing' | translate }}"
                      (click)="openSupplierInventoryDialog(attr['supplier_invoice']['item_id'])"
                    >
                    </fa-icon>

                    <fa-icon
                      *ngIf="!attr['supplier_invoice']['item_id']"
                      matTooltipClass="tooltip-space"
                      matTooltip="{{ 'create_item' | translate }}"
                      class="pl-1 pr-1 pb-2 pt-2 text-success col-sm-3"
                      [icon]="['fas', 'plus-circle']"
                      (click)="createItem(attr)">
                    </fa-icon>

                    <fa-icon
                      [popover]="selectRelateJob"
                      [outsideClick]="true"
                      containerClass="m-2"
                      placement="top"
                      matTooltip="{{ getJobLineItemToolTip(attr['supplier_invoice']) }}"
                      class="pl-1 pr-1 pb-2 pt-2 pointer col-sm-3"
                      [ngClass]="attr['supplier_invoice']['job_id'] ? 'text-success' : 'text-secondary'"
                      [icon]="['fas','briefcase']">
                    </fa-icon>

                    <ng-template #selectRelateJob>
                      <div
                        class="d-flex d-flex-gap flex-column"
                        style="width: 200px;"
                      >
                        <div id="job">
                          <fieldmagic-relate-input
                            label="select_job"
                            moduleName="jobs"
                            [(ngModel)]="attr['job_data']"
                            (change)="onChangeJobLineItem($event, attr)"
                            placeholder="select_job"
                          >
                          </fieldmagic-relate-input>
                        </div>

                        <div
                          *ngIf="attr | data_get: 'job_data.enable_cost_centers'"
                          id="job_task"
                        >
                          <fieldmagic-relate-input
                            label="Select a task"
                            moduleName="job_tasks"
                            [filter]="{
                              job_id: (attr | data_get: 'job_data.id') | fallback: (attr | data_get: 'job_data.job_id')
                            }"
                            [(ngModel)]="attr['job_task_id']"
                            (ngModelChange)="onSelectTask(attr)"
                            placeholder="select_task"
                          >
                          </fieldmagic-relate-input>
                        </div>
                      </div>
                    </ng-template>

                  </div>
                  <div class="draggable-table-box" [ngStyle]="{ width: bDepartmentTracking ? '17%' : '30%'}">
                    <textarea
                      class="form-control invoice-desc-{{i}}" style="font-size: 12px;"
                      placeholder="{{ 'description' | translate }}"
                      [ngModelOptions]="{standalone: true}"
                      [(ngModel)]="attr['supplier_invoice']['description']"
                      [ngClass]="{'is-invalid': (validateField(attr['supplier_invoice']['description'])) && isTouched}"
                      (focus)="increaseRow(i)"
                      (focusout)="decreaseRow(i)"
                      (ngModelChange)="markAsDirty()"
                      #invoiceLineDesc>
                  </textarea>
                  </div>
                  <div *ngIf="bDepartmentTracking" class="draggable-table-box" style="width: 12%">
                    <fieldmagic-relate-input
                      moduleName="departments"
                      [(ngModel)]="attr['department']"
                      (change)="selectDepartment($event, attr)"
                      [errorneous]="validateField(attr['supplier_invoice']['department_id']) && isTouched"
                      placeholder="select_department"
                    ></fieldmagic-relate-input>
                  </div>
                  <div class="draggable-table-box" style="width: 10%">
                    <fieldmagic-decimal-input
                      (change)="quantityChange($event, attr)"
                      customClass="form-control font-size-12 input-height-40"
                      placeholder="{{ 'quantity' | translate }}"
                      [ngModelOptions]="{standalone: true}"
                      [(ngModel)]="attr['supplier_invoice']['quantity']"
                      disableScroll>
                    </fieldmagic-decimal-input>
                  </div>
                  <div class="draggable-table-box" style="width: 10%">
                    <fc-currency-input
                      [places]="4"
                      id="unit_cost_{{ i }}"
                      [(ngModel)]="attr['supplier_invoice']['unit_cost']"
                      [ngModelOptions]="{standalone: true}"
                      [customClass]="'form-control font-size-12 input-height-40'"
                      (change)="unitCostChange($event, attr)"
                      decimalPipe
                      disableScroll>
                    </fc-currency-input>
                  </div>
                  <div class="draggable-table-box" style="width: 12%">
                    <fieldmagic-relate-input
                      moduleName="tax_codes"
                      [filter]="arTaxCodeFilter"
                      [(ngModel)]="attr['tax']"
                      (change)="selectATaxcode($event, attr)"
                      [errorneous]="(validateField(attr['supplier_invoice']['tax_code_id']) || attr['tax'] == null) && isTouched"
                      placeholder="tax_code"
                    ></fieldmagic-relate-input>
                  </div>
                  <div class="draggable-table-box" style="width: 12%">
                    <fieldmagic-relate-input
                      moduleName="account_codes"
                      [filter]="arAccountCodeFilter"
                      [(ngModel)]="attr['account_code']"
                      (change)="selectAccountCode($event, attr)"
                      [errorneous]="(validateField(attr['supplier_invoice']['account_code_id']) || attr['account_code'] == null) && isTouched"
                      placeholder="account_code"
                    ></fieldmagic-relate-input>
                  </div>
                  <div class="draggable-table-box" style="width: 10%">
                    <fc-currency-input
                      customClass="form-control font-size-12 input-height-40"
                      [(ngModel)]="attr['amount']"
                      (change)="onLineTotalChange($event.target, {attr: attr, index: i})"
                      disableScroll
                    ></fc-currency-input>
                  </div>
                  <div class="draggable-table-box p-2" style="width: 3%">
                    <input
                      type="checkbox"
                      [checked]="attr.update_supplier_pricing"
                      matTooltip="{{ 'create_update_supplier_pricing' | translate }}"
                      (change)="onChangeCheckbox($event, 'update_supplier_pricing', attr, false)"
                      [disabled]="!attr['supplier_invoice']['item_id']"
                    />
                  </div>
                  <div class="draggable-table-box p-2" style="width: 3%">
                    <input
                      type="checkbox"
                      [checked]="attr.update_product_supplier"
                      matTooltip="{{ 'update_product_preferred_supplier' | translate }}"
                      (change)="onChangeCheckbox($event, 'update_product_supplier', attr, false); onChangeSupplierCheckbox($event, attr, false);"
                      [disabled]="!attr['supplier_invoice']['item_id']"
                    />
                  </div>
                  <div class="draggable-table-box p-2" style="width: 3%">
                    <input
                      type="checkbox"
                      [checked]="attr.update_product_buy_price"
                      matTooltip="{{ 'update_product_buy_price' | translate }}"
                      (change)="onChangeCheckbox($event, 'update_product_buy_price', attr, false)"
                      [disabled]="!attr['supplier_invoice']['item_id']"
                    />
                  </div>
                </div>
              </div>
            </ng-container>

            <div class="col-12 text-center" *ngIf="arLineAttributes.length < 1" [shAttachMenu]="contextMenuComponent?.menu" [shMenuData]="contextMenuService.formatMenuData([], -1)">
              <div class="draggable-table-box border border-top-0 p-3">
                <span>{{ 'no_invoice_line' | translate }}</span>
              </div>
            </div>

            <div *ngIf="!bInvoiceLineLoaded" class="col-12 text-center" style="font-size: 16px;">
              <div class="draggable-table-box border border-top-0">
                <fa-icon [icon]="['fas', 'spinner']" [spin]="true" aria-hidden="true"></fa-icon>
              </div>
            </div>

          </div>
        </div>

      </div>

      <div *ngIf="bInvoiceLineLoaded" class="row">
        <div class="col-12">
          <div class="d-flex flex-row border border-top-0">
            <div class="draggable-table-box right-items" style="width: 90%;">
              <span class="p-2">{{ 'total_ex_tax' | translate }}</span>
            </div>
            <div class="draggable-table-box left-items" style="width: 10%;">
              <span class="ml-2">{{ computeInvoiceLineExcludedTax() | currency: {decimal_places: 2} }}</span>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="d-flex flex-row border border-top-0">
            <div class="draggable-table-box right-items" style="width: 90%;">
              <span class="p-2  float-right">{{ 'tax' | translate }}</span>
            </div>
            <div class="draggable-table-box left-items" style="width: 10%;">
              <span class="ml-2">{{ computeInvoiceLineTax() | currency: {decimal_places: 2} }}</span>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="d-flex flex-row border border-top-0">
            <div class="draggable-table-box right-items" style="width: 90%;">
              <span class="p-2 float-right">{{ 'tax_adjustment_amount' | translate }}</span>
            </div>
            <div class="draggable-table-box center-items" style="width: 10%;">
              <fc-currency-input
                step="0.01"
                [withControls]="true"
                customClass="form-control font-size-12 input-height-40"
                [(ngModel)]="totalTaxAdjustment"
                (change)="onTaxAdjustment()"
                disableScroll>
              </fc-currency-input>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="d-flex flex-row border border-top-0">
            <div class="draggable-table-box right-items" style="width: 90%;">
              <span class="p-2  float-right">{{ 'total_inc_tax' | translate }}</span>
            </div>
            <div class="draggable-table-box center-items" style="width: 10%;">
              <fc-currency-input
                id="invoiceLineIncludedTaxField"
                [(ngModel)]="invoiceLineIncludedTax"
                customClass="form-control input-height-40 font-size-12"
                disableScroll>
              </fc-currency-input>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</div>
</ng-template>
</ng-container>

<fc-context-menu (isClicked)="doSomethingFromContextMenu($event)"></fc-context-menu>

<ng-template #createSIDisabled>
  <span id="btnCreateSIDisabled" class="disabled"
    matTooltip="{{ 'forbidden_action_error' | translate }}">
    {{ 'forbidden_action_error' | translate }}
  </span>
</ng-template>
